import request from "../../utils/request";

export interface MissionStatementView {
  id: number;
  userId: string;
  userName: string;
  userImageUrl: string | null;
  statement: string;
  rating: number;
  isShared: boolean;
  createdOn: string;
  updatedOn: string | null;
}

export interface MissionStatementInput {
  statement: string;
  rating: number;
  isShared: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const extractPayload = <T>(response: any): T => {
  if (!response) throw new Error("No response received");
  if (response.payload !== undefined) return response.payload;
  if (response.data && response.data.payload !== undefined) return response.data.payload;
  return response;
};

export async function getCompanyMission(): Promise<string | null> {
  const response = await request.get("MissionStatement/GetCompanyMission");
  return extractPayload<string | null>(response.data);
}

export async function updateCompanyMission(mission: string): Promise<boolean> {
  const response = await request.put("MissionStatement/UpdateCompanyMission", { mission });
  return extractPayload<boolean>(response.data);
}

export async function getMyStatement(): Promise<MissionStatementView | null> {
  const response = await request.get("MissionStatement/GetMyStatement");
  return extractPayload<MissionStatementView | null>(response.data);
}

export async function createOrUpdateStatement(input: MissionStatementInput): Promise<MissionStatementView> {
  const response = await request.post("MissionStatement/CreateOrUpdate", input);
  return extractPayload<MissionStatementView>(response.data);
}

export async function getTeamStatements(): Promise<MissionStatementView[]> {
  const response = await request.get("MissionStatement/GetTeamStatements");
  return extractPayload<MissionStatementView[]>(response.data);
}
